import { StringObjectDictionary } from "../Types"

// Types
export type OrganizationModelType = {
    id: string
    name: string
    description: string
    contact: string
    address: string
    postaladdress: string
    organizationnumber: string
    billingemail: string
    showonmap?: boolean
    organizationowneruserid: string
    sys_datemodified_utc_epoch: number
    sys_datecreated_utc_epoch: number
    weburl: string

    billingcustomernumber: string
    billingdiscount: string
    billingnotes: string
    billing: boolean
    billingcurrency: string

    customercontactname: string
    customercontactaddress: string
    customercontactphone: string
    customercontactemail: string
    customercontactweb: string
    customercontactfacebook: string
    customercontactinstagram: string

    locationLatitude: number
    locationLongitude: number,
    typeOfBusiness: any,

    trialexpires?: number,
    premiumexpires?: number,
    istestorganization?: boolean
}
export type OrganizationUsersModelType = {
    id: string
    alias: string
    email: string
    role: OrganizationUsersRoleType
    organizationId: string
}
export type OrganizationUsersRoleType = "NONE" | "OWNER" | "MEMBER";


const CHANGE_ORG_ORGANIZATION = "CHANGE_ORG_ORGANIZATION";
const CHANGE_ORG_ORGANIZATION_USERS = "CHANGE_ORG_ORGANIZATION_USERS";

// 
export type OrganizationReducerType = {
    organizations: StringObjectDictionary<OrganizationModelType>,
    organizationUsers: StringObjectDictionary<OrganizationUsersModelType>,
}

const organizationReducerStore: OrganizationReducerType = {
    organizations: {},
    organizationUsers: {},
};

const organizationReducer = (state = { ...organizationReducerStore }, action) => {
    switch (action.type) {
        case CHANGE_ORG_ORGANIZATION: { state = { ...state, organizations: action.payload }; break; }
        case CHANGE_ORG_ORGANIZATION_USERS: { state = { ...state, organizationUsers: action.payload }; break; }
        default: { return state; }
    }
    return state;
};

export {
    organizationReducer,
    CHANGE_ORG_ORGANIZATION,
    CHANGE_ORG_ORGANIZATION_USERS
}